import SearchHero from '@/components/Search/SearchHero.jsx';

const SearchPage = () => <SearchHero fullHeight />;

export default SearchPage;
